import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import CustomerService from "../../services/CustomerService";
import { toast } from "react-toastify";
import "./AddCustomerModal.css";

const AddCustomerModal = ({ showModal, handleClose, onCustomerAdded }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const saveCustomer = async () => {
    try {
      const response = await CustomerService.create(formData);
      toast.success(response?.data?.message || "Customer added successfully", {
        autoClose: 2000,
      });
      onCustomerAdded(); 
      handleClose();
      setFormData({ firstName: "", lastName: "", email: "", phone: "", address: "" }); 
    } catch (error) {
      console.error("Failed to add customer:", error);
      toast.error("Failed to add customer");
    }
  };

  return (
    <Modal className="add-customer-modal" show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title className="title">Add New Customer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="form-group">
            <label>First Name</label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleInputChange}
              placeholder="First Name"
              required
            />
          </div>
          <div className="form-group">
            <label>Last Name</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
              placeholder="Last Name"
              required
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Email"
              required
            />
          </div>
          <div className="form-group">
            <label>Phone</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="Phone Number"
              required
            />
          </div>
          <div className="form-group">
            <label>Address</label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              placeholder="Address"
              required
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end w-100">
          <Button variant="primary" onClick={saveCustomer} className="w-100">
            Save
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCustomerModal;
